import { createAsyncThunk } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getSurveys = createAsyncThunk<any, any>(
  types.GET_SURVEYS,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const surveys = isRootAdmin
      ? await api.getSurveys(params)
      : await api.getSchoolSurveys({ schoolId: user.schoolId, params });

    return surveys;
  },
);

export const getSurveysByStudentId = createAsyncThunk<any, any>(
  types.GET_SURVEYS_BY_STUDENT_ID,
  async ({
    studentId,
    ...params
  }: {
    studentId: string;
    params: Record<string, any>;
  }) => {
    const surveys = await api.getSurveysByStudentId({
      studentId,
      params,
    });

    return surveys;
  },
);
